import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from "jquery";

import Header from "./header";
import HomeSlide from "./homeSlide";
import InteractiveContentCards from "./interactiveContentCards";
import CalcForm from "./calcForm";
import LivestreamModal from "./livestreamModal";

$(document).ready(() => {
  const header = new Header();
  if ($(".home-slider").length) {
    const homeSlide = new HomeSlide();
  }
  if ($(".secinteractivecontentcards").length) {
    const homeSlide = new InteractiveContentCards();
  }
  if ($("#wf-form-Calc-Form").length) {
    const calcForm = new CalcForm();
  }
  if ($(".js-livestream-modal").length) {
    const livestreamModal = new LivestreamModal();
  }
});
